<app-toolbar></app-toolbar>

<div class="admin-container">
  <div class="admin-header">
    <div class="header-title">
      <h1>User Management</h1>
    </div>

    <div class="header-actions">
      <div class="counters">
        <div class="counter-item">
          <div class="counter-value">{{ adminCount }}</div>
          <img src="assets/icons/admin.svg" alt="Admin" class="counter-icon" />
        </div>

        <div class="counter-item">
          <div class="counter-value">{{ editorCount }}</div>
          <img
            src="assets/icons/editor.svg"
            alt="Editor"
            class="counter-icon"
          />
        </div>

        <div class="counter-item">
          <div class="counter-value">{{ viewersCount }}</div>
          <img
            src="assets/icons/viewer.svg"
            alt="Viewers"
            class="counter-icon"
          />
        </div>

        <div class="counter-item">
          <div class="counter-value">{{ restrictedViewersCount }}</div>
          <img
            src="assets/icons/viewer-limited.svg"
            alt="Restricted Viewers"
            class="counter-icon"
          />
        </div>
      </div>

      <button class="add-user-btn" (click)="addUser()">
        <svg
          class="btn-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        </svg>
        Add User
      </button>
    </div>
  </div>

  <div class="search-container">
    <svg
      class="search-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      />
    </svg>
    <input
      type="text"
      class="search-input"
      placeholder="Search"
      [(ngModel)]="searchTerm"
      (input)="onSearchChange()"
    />
  </div>

  <div class="table-container">
    <table class="users-table">
      <thead>
        <tr>
          <th>PRID</th>
          <th>Name</th>
          <th>Role</th>
          <th>Projects</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of filteredUsers; let i = index" class="user-row">
          <td>{{ user.pridId }}</td>
          <td>{{ user.name || user.pridId }}</td>
          <td class="role-cell" (click)="openRoleDialog(i)">
            <img
              [src]="getRoleInfo(user.userType)?.icon"
              [alt]="user.userType"
              class="role-icon-table"
              style="
                width: 20px;
                height: 20px;
                margin-right: 8px;
                vertical-align: middle;
              "
            />
            {{ user.userType }}
          </td>
          <td>
            <span class="projects-list">
              {{
                user.userType !== "viewer_restricted"
                  ? "All"
                  : (user.projects || []).join(", ")
              }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Role Change Dialog -->
  <div
    *ngIf="showRoleDialog"
    class="role-dialog-overlay"
    (click)="closeRoleDialog()"
  >
    <div class="role-dialog" (click)="$event.stopPropagation()">
      <div class="role-dialog-header">
        <h3>Role Change</h3>
        <button class="close-btn" (click)="closeRoleDialog()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>
      </div>

      <!-- Confirmation View -->
      <div *ngIf="showConfirmation" class="confirmation-content">
        <p class="role-dialog-subtitle" *ngIf="getSelectedUser()">
          Change the role of {{ getSelectedUser()?.pridId }}?
        </p>

        <!-- Current Role Card -->
        <div
          class="role-option-card current-role"
          *ngIf="
            getSelectedUser()?.userType &&
            getRoleInfo(getSelectedUser()!.userType) as currentRole
          "
        >
          <div class="role-card-content">
            <img
              [src]="currentRole.icon"
              [alt]="currentRole.title"
              class="role-icon"
            />
            <div class="role-info">
              <div class="role-title-row">
                <h4>{{ currentRole.title }}</h4>
                <span class="current-badge">Current</span>
              </div>
              <p>{{ currentRole.description }}</p>
            </div>
          </div>
        </div>

        <!-- Arrow -->
        <div class="change-arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </div>

        <!-- New Role Card -->
        <div
          class="role-option-card"
          *ngIf="newRoleType && getRoleInfo(newRoleType) as newRole"
        >
          <div class="role-card-content">
            <img [src]="newRole.icon" [alt]="newRole.title" class="role-icon" />
            <div class="role-info">
              <h4>{{ newRole.title }}</h4>
              <p>{{ newRole.description }}</p>
            </div>
          </div>
        </div>

        <!-- Project Selection for Viewer Restricted -->
        <div
          *ngIf="newRoleType === 'viewer_restricted'"
          class="project-selection"
        >
          <p class="role-dialog-subtitle">Projects:</p>
          <div class="user-inputs">
            <div class="project-options">
              <label *ngFor="let project of projects" class="project-option">
                <input
                  type="checkbox"
                  [value]="project"
                  [checked]="selectedProjectsForRoleChange.includes(project)"
                  (change)="onProjectCheckboxChangeForRole($event, project)"
                />
                <span>{{ project }}</span>
              </label>
            </div>
            <p
              class="selected-count"
              *ngIf="selectedProjectsForRoleChange.length > 0"
            >
              {{ selectedProjectsForRoleChange.length }} project(s) selected
            </p>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="confirmation-actions">
          <button class="cancel-btn" (click)="cancelRoleChange()">
            Cancel
          </button>
          <button
            class="confirm-btn"
            (click)="confirmRoleChange()"
            [disabled]="
              newRoleType === 'viewer_restricted' &&
              selectedProjectsForRoleChange.length === 0
            "
          >
            Confirm
          </button>
        </div>

        <!-- Back Link -->
        <div class="back-link">
          <button (click)="backToRoles()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
            Back to TechStack roles
          </button>
        </div>
      </div>

      <!-- Role Selection View -->
      <div *ngIf="!showConfirmation" style="padding: 1.5rem">
        <p class="role-dialog-subtitle" *ngIf="getSelectedUser()">
          Select a role for {{ getSelectedUser()?.pridId }}
        </p>

        <div class="role-options">
          <div
            *ngFor="let role of availableRoles"
            class="role-option-card"
            [class.current-role]="getSelectedUser()?.userType === role.type"
            (click)="selectRole(role.type)"
          >
            <div class="role-card-content">
              <img [src]="role.icon" [alt]="role.title" class="role-icon" />
              <div class="role-info">
                <div class="role-title-row">
                  <h4>{{ role.title }}</h4>
                  <span
                    *ngIf="getSelectedUser()?.userType === role.type"
                    class="current-badge"
                  >
                    Current
                  </span>
                </div>
                <p>{{ role.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Add User Dialog -->
  <div
    *ngIf="showAddUserDialog"
    class="role-dialog-overlay"
    (click)="closeAddUserDialog()"
  >
    <div class="role-dialog" (click)="$event.stopPropagation()">
      <div class="role-dialog-header">
        <h3>Add User</h3>
        <button class="close-btn" (click)="closeAddUserDialog()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>
      </div>

      <div class="add-user-content" *ngIf="!showAddUserConfirmation">
        <!-- User Inputs -->
        <form [formGroup]="addUserForm">
          <p class="role-dialog-subtitle">PRID:</p>
          <div class="user-inputs">
            <input
              id="prid"
              type="text"
              class="user-input"
              placeholder="Enter PRID"
              formControlName="prid"
            />
          </div>

          <p class="role-dialog-subtitle">Name:</p>
          <div class="user-inputs">
            <input
              id="name"
              type="text"
              class="user-input"
              placeholder="Enter Name"
              formControlName="name"
            />
          </div>

          <!-- Role Selection -->
          <p class="role-dialog-subtitle">Role:</p>

          <div class="role-options">
            <div
              *ngFor="let role of availableRoles"
              class="role-option-card"
              [class.selected-role]="
                addUserForm.get('role')?.value === role.type
              "
              (click)="selectRoleForNewUser(role.type)"
            >
              <div class="role-card-content">
                <img [src]="role.icon" [alt]="role.title" class="role-icon" />
                <div class="role-info">
                  <div class="role-title-row">
                    <h4>{{ role.title }}</h4>
                  </div>
                  <p>{{ role.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="confirmation-actions">
            <button
              class="cancel-btn"
              type="button"
              (click)="closeAddUserDialog()"
            >
              Cancel
            </button>
            <button
              class="confirm-btn"
              type="button"
              (click)="proceedToAddUserConfirmation()"
              [disabled]="!addUserForm.valid"
            >
              Add User
            </button>
          </div>
        </form>
      </div>

      <!-- Confirmation View -->
      <div class="add-user-content" *ngIf="showAddUserConfirmation">
        <p class="role-dialog-subtitle">
          Confirm the role of {{ addUserFormValue.name }}?
        </p>

        <div class="role-options">
          <div class="role-option-card selected-role">
            <div class="role-card-content">
              <img
                [src]="getRoleInfo(addUserFormValue.role)?.icon"
                [alt]="getRoleInfo(addUserFormValue.role)?.title"
                class="role-icon"
              />
              <div class="role-info">
                <div class="role-title-row">
                  <h4>{{ getRoleInfo(addUserFormValue.role)?.title }}</h4>
                </div>
                <p>{{ getRoleInfo(addUserFormValue.role)?.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Project Selection for Viewer Restricted -->
        <div
          *ngIf="addUserFormValue.role === 'viewer_restricted'"
          class="project-selection"
        >
          <p class="role-dialog-subtitle">Projects:</p>
          <div class="user-inputs">
            <div class="project-options">
              <label *ngFor="let project of projects" class="project-option">
                <input
                  type="checkbox"
                  [value]="project"
                  [checked]="selectedProjects.includes(project)"
                  (change)="onProjectCheckboxChange($event, project)"
                />
                <span>{{ project }}</span>
              </label>
            </div>
            <p class="selected-count" *ngIf="selectedProjects.length > 0">
              {{ selectedProjects.length }} project(s) selected
            </p>
          </div>
        </div>

        <!-- Confirmation Actions -->
        <div class="confirmation-actions">
          <button class="cancel-btn" (click)="closeAddUserDialog()">
            Cancel
          </button>
          <button
            class="confirm-btn"
            (click)="confirmAddUser()"
            [disabled]="
              addUserFormValue.role === 'viewer_restricted' &&
              selectedProjects.length === 0
            "
          >
            Confirm
          </button>
        </div>

        <!-- Back Link -->

        <div class="back-link">
          <button (click)="backToAddUserForm()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
            Back
          </button>
        </div>

        <!-- <button class="back-link" (click)="backToAddUserForm()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Back
        </button> -->
      </div>
    </div>
  </div>
</div>
